module.exports = __webpack_public_path__ + "static/media/banano2.b30d7e42.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pioricost-fruit/banano/banano2.jpeg
// module id = 39
// module chunks = 0